'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobConnectureOrg } from '../../Entities/Glob/GlobConnectureOrg';
import { GlobConnectureOrgCollection } from '../../Collections/Glob/GlobConnectureOrgCollection';

export class GlobConnectureOrgRepository extends CoreRepository {
  public getGlobConnectureOrgs() {
    return this.webAPI.getGlobConnectureOrgs().then((response) => {
      const collection = new GlobConnectureOrgCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobConnectureOrg();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public validateUserConnecture(reference: string, options: object = {}) {
    return this.webAPI.validateUserConnecture(reference, options).then((response) => {
      return response;
    });
  }

  /*
    public getGlobConnectureOrg(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getGlobConnectureOrg(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let GlobConnectureOrg = new GlobConnectureOrg();
            GlobConnectureOrg.hydrate(response);

            return GlobConnectureOrg;
        });
    }

    public createGlobConnectureOrg(payload: object = {}){  
    return this.webAPI.createGlobConnectureOrg(payload)
      .then( response => {
        let GlobConnectureOrg = new GlobConnectureOrg();
        GlobConnectureOrg.hydrate(response);

        return GlobConnectureOrg;
      });
    }

    public updateGlobConnectureOrg(payload: object = {}){  
        return this.webAPI.updateGlobConnectureOrg(payload)
        .then( response => {
            let GlobConnectureOrg = new GlobConnectureOrg();
            GlobConnectureOrg.hydrate(response);

            return GlobConnectureOrg;
        });
    }

    public removeGlobConnectureOrg( ){
        return this.webAPI.removeGlobConnectureOrg()
        .then( response => {
            return response;
        });
    }
    */
}
